import BaseStore from './BaseStore'

export class DocumentTypeStore extends BaseStore {
  constructor() {
    super()
    this.endpoint = 'document_types'
  }
}

export default new DocumentTypeStore()


// WEBPACK FOOTER //
// ./src/stores/DocumentTypeStore.js